import React, {useState} from "react";
import {ErrorMessage, Field, Form, Formik} from "formik";
import Select, {createFilter} from "react-select";
import Input from "../../../common/form-elements/input/input";
import FormErrorMessage from "../../../common/form-elements/form-error-message/form-error-message";
import AdvancedQueryBuilder from "../../../common/advanced-query-builder/advanced-query-builder";
/* Validations */
import {
    maxLength,
    minLength,
    required,
    requiredSelect,
    schemaValidate,
} from "../../../../helpers/validation-helpers";

import {
    getFilterProperties,
    getColumnsData,
} from "../../../../pagingfeed/column-helpers/filterProperties";
import {CHART_TYPE_OPTIONS, DATA_OPTIONS} from "./data-chart-options";
import IconButton from "../../../common/icon-button/icon-button";
import ModalDefault from "../../../common/modal/modal-default";
import {NUMBER_OF_ITEMS_OPTIONS} from "../widget-constants";

const DataChartForm = ({
    initialValues,
    onFormSubmit,
    handleFormFieldChange,
    handleDataTypeChange,
    dataPropertyOptions,
    tempConfigData,
    onCancel,
    isLoadingColumnConfig,
}) => {
    const [showFilterConfig, setShowFilterConfig] = useState(false);

    const toggleFilterModal = () => setShowFilterConfig((showFilterConfig) => !showFilterConfig);

    return (
        <Formik initialValues={initialValues} onSubmit={onFormSubmit}>
            {(props) => {
                return (
                    <Form>
                        <div className="glu-modal__body">
                            <div className="glu-content__section">
                                <div className="glu-form-row">
                                    <div className="glu-label">Widget Title</div>
                                    <Field
                                        as={Input}
                                        name="title"
                                        className="glu-form-input-pad"
                                        autoFocus
                                        placeholder="Input title"
                                        value={props.values.title}
                                        onChange={handleFormFieldChange("title", props)}
                                        validate={schemaValidate([
                                            required(),
                                            minLength(),
                                            maxLength(30),
                                        ])}
                                        invalid={props.errors.title && props.touched.title}
                                    />
                                    <ErrorMessage name="title" component={FormErrorMessage} />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Number of items</div>
                                    <Field
                                        as={Select}
                                        name="numberOfItems"
                                        placeholder="Select the number of items"
                                        value={props.values.numberOfItems}
                                        options={NUMBER_OF_ITEMS_OPTIONS}
                                        onChange={handleFormFieldChange("numberOfItems", props)}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        filterOption={createFilter({
                                            matchFrom: "any",
                                            stringify: (option) => `${option.label}`,
                                        })}
                                    />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Data</div>
                                    <Field
                                        as={Select}
                                        name="dataType"
                                        placeholder="Select data type"
                                        value={props.values.dataType}
                                        options={DATA_OPTIONS}
                                        onChange={handleDataTypeChange("dataType", props)}
                                        validate={schemaValidate([requiredSelect().nullable()])}
                                        invalid={props.errors.dataType && props.touched.dataType}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        filterOption={createFilter({
                                            matchFrom: "any",
                                            stringify: (option) => `${option.label}`,
                                        })}
                                    />
                                    <ErrorMessage name="dataType" component={FormErrorMessage} />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Property</div>
                                    <Field
                                        as={Select}
                                        name="dataProperty"
                                        placeholder={
                                            props.values.dataType && "Select data property"
                                        }
                                        value={props.values.dataProperty}
                                        options={dataPropertyOptions}
                                        validate={schemaValidate([requiredSelect().nullable()])}
                                        invalid={
                                            props.errors.dataProperty && props.touched.dataProperty
                                        }
                                        onChange={handleFormFieldChange("dataProperty", props)}
                                        isDisabled={props.values.dataType === null}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        filterOption={createFilter({
                                            matchFrom: "any",
                                            stringify: (option) => `${option.label}`,
                                        })}
                                    />
                                    <ErrorMessage
                                        name="dataProperty"
                                        component={FormErrorMessage}
                                    />
                                </div>
                                <div className="glu-form-row">
                                    <div className="glu-label">Chart type</div>
                                    <Field
                                        as={Select}
                                        name="chartType"
                                        placeholder="Select chart type"
                                        value={props.values.chartType}
                                        options={CHART_TYPE_OPTIONS}
                                        onChange={handleFormFieldChange("chartType", props)}
                                        className="glu-select glu-form-input-pad"
                                        classNamePrefix="react-select"
                                        filterOption={createFilter({
                                            matchFrom: "any",
                                            stringify: (option) => `${option.label}`,
                                        })}
                                    />
                                </div>

                                <div className="glu-form-row">
                                    <div className="glu-flex-row">
                                        <IconButton
                                            icon="filter"
                                            text={
                                                Object.keys(tempConfigData.filter.mongoQuery || {})
                                                    .length
                                                    ? "Configure filter"
                                                    : "Add filter"
                                            }
                                            onClick={toggleFilterModal}
                                            className={`glu-flex-shrink ${
                                                Object.keys(tempConfigData.filter.mongoQuery || {})
                                                    .length
                                                    ? "active"
                                                    : ""
                                            }`}
                                            isDisabled={
                                                Object.keys(tempConfigData.dataType).length === 0
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <footer className="glu-modal__footer">
                            <div className="glu-flex-grow glu-flex-row">
                                <div className="glu-flex-grow text-right">
                                    <button
                                        onClick={onCancel}
                                        className="glu-btn glu-btn--secondary"
                                        type="button"
                                    >
                                        Cancel
                                    </button>
                                </div>
                                <div className="glu-flex-shrink">
                                    <button
                                        className="glu-btn glu-btn--primary"
                                        type="submit"
                                        disabled={isLoadingColumnConfig}
                                    >
                                        {isLoadingColumnConfig ? "Loading..." : "Save"}
                                    </button>
                                </div>
                            </div>
                        </footer>
                        <ModalDefault isOpen={showFilterConfig} customClass="glu-modal__filter">
                            <div className="glu-modal-content">
                                <div className="glu-modal__header">
                                    <div className="glu-modal__title glu-flex-grow">Filter</div>
                                    <div className="glu-flex-shrink">
                                        <button
                                            aria-label="close"
                                            type="button"
                                            className="glu-btn-link g-icon g-icon-close"
                                            onClick={toggleFilterModal}
                                        />
                                    </div>
                                </div>
                                <div className="glu-modal__body">
                                    <div className="glu-content__section">
                                        <Field name="filter">
                                            {() => (
                                                <AdvancedQueryBuilder
                                                    saveFilter={handleFormFieldChange(
                                                        "filter",
                                                        props
                                                    )}
                                                    closeConfigModal={toggleFilterModal}
                                                    tree={tempConfigData.filter.tree}
                                                    type={tempConfigData.dataType}
                                                    columns={getColumnsData(
                                                        getFilterProperties(
                                                            tempConfigData.dataType.value
                                                        ),
                                                        tempConfigData.columnsConfig
                                                    )}
                                                    filterData={tempConfigData.filter.mongoQuery}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </div>
                            </div>
                        </ModalDefault>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default DataChartForm;
